import * as React from "react";

import { Step } from "../../FormParts/Tour/TourTypes";
import { ControlReference } from "../../../Engine/Core/ControlDispatcher/ControlReference";
import { AnyContext } from "../../TypingUtils";

import { TourStepsContext, tourStepsContextTypes } from "./TourStepsContext";
import { TourStepsContextObject } from "./TourStepsContextObject";

interface TourStepsStorageProps {
    children: React.ReactNode;
}

export class TourStepsStorage extends React.Component<TourStepsStorageProps> {
    public static childContextTypes = tourStepsContextTypes;
    private readonly tourSteps = new Map<string, Step>();
    private readonly childContext: TourStepsContext;

    public constructor(props: TourStepsStorageProps, context: AnyContext) {
        super(props, context);
        this.childContext = {
            addTourStep: this.addTourStep,
            removeTourStep: this.removeTourStep,
            getTourSteps: this.getTourSteps,
        };
    }

    public getChildContext(): TourStepsContext {
        return this.childContext;
    }

    private readonly getTourSteps = () => [...this.tourSteps.values()];

    public render(): JSX.Element {
        return (
            <TourStepsContextObject.Provider value={this.childContext}>
                {this.props.children}
            </TourStepsContextObject.Provider>
        );
    }

    private readonly addTourStep = (step: Step, control?: ControlReference): void => {
        if (this.tourSteps.has(step.id)) {
            return;
        }
        this.tourSteps.set(step.id, { ...step, control: control });
    };

    private readonly removeTourStep = (control: ControlReference): void => {
        const tourStepEntries = [...this.tourSteps.entries()];
        for (const [id, step] of tourStepEntries) {
            if (step.control === control) {
                this.tourSteps.delete(id);
                return;
            }
        }
    };
}
